/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { useQuery } from '@tanstack/react-query';
import { dataIntegrityService } from '@/services/superadmin/data-integrity.service';

const dataIntegrityKeys = {
  scan: ['data-integrity', 'scan'] as const,
};

export function useDataIntegrityScan(enabled = false) {
  return useQuery({
    queryKey: dataIntegrityKeys.scan,
    queryFn: () => dataIntegrityService.scan(),
    enabled,
    staleTime: 0,
    gcTime: 5 * 60 * 1000,
  });
}
